import styled from 'styled-components';

import { ContainerProps } from './interface';

export const Container = styled.td<ContainerProps>`
  width: ${props => (props.width ? `${props.width}px !important` : 'auto')};

  padding: 1rem;
  font-size: 0.8rem;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  min-height: 50px;

  background: ${({ theme }) => theme.colors.LIGHT1};
  font-weight: 700;

  @media (max-width: 1600px) {
    font-size: 0.7rem;
    padding: 0.5rem;
  }

  &:first-child {
    border: none;
  }

  &:last-child {
  }

  strong {
    font-weight: 700;
  }

  span {
    margin: 0px;
    padding: 0px;
    flex: 1;
    cursor: pointer;
    text-decoration: ${props => (props.active ? 'underline' : 'normal')};
    color: ${({ theme }) => theme.colors.TEXT1};
  }

  span:hover {
    text-decoration: underline;
  }

  i {
    margin: 0px;
    padding: 0px;
  }
`;
